import React from 'react';
import { GetServerSideProps, NextPage } from 'next';

import ShippingDestinations from '../components/ShippingDestinations';
import Head from '../components/Head';
import { getPropsForPageLoad } from '../utils/pageLoad';

const ShippingDestinationsPage: NextPage = () => (
  <>
    <Head title="Shipping Destinations" url="/shipping-destinations" />
    <ShippingDestinations />
  </>
);

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const propsForPageLoad = await getPropsForPageLoad(ctx);

  return {
    props: {
      ...propsForPageLoad,
    },
  };
};

export default ShippingDestinationsPage;
